(ns web3.structured-data
  (:require [reagent.core :as r]
            ["react-structured-data" :as structured]))

(def JSONLD (r/adapt-react-class structured/JSONLD))

(def generic (r/adapt-react-class structured/Generic))
(def generic-collection (r/adapt-react-class structured/GenericCollection))

(def Product (r/adapt-react-class structured/Product))

(comment

  ;; everything defined by structured-data package
  (def AggregateRating (r/adapt-react-class structured/AggregateRating))
  (def Answer (r/adapt-react-class structured/Answer))
  (def Author (r/adapt-react-class structured/Author))
  (def Graph (r/adapt-react-class structured/Graph))
  (def ItemReviewed (r/adapt-react-class structured/ItemReviewed))
  (def Location (r/adapt-react-class structured/Location))
  (def Question (r/adapt-react-class structured/Question))
  (def Rating (r/adapt-react-class structured/Rating))
  (def Review (r/adapt-react-class structured/Review))
  (def Reviews (r/adapt-react-class structured/Reviews)))